import { Button, Text, Title } from "@mantine/core";
import IconRocket from "@src/assets/icons/lucide/rocket.svg?react";
import clsx from "clsx";

type CollectNotesEmptyStateProps = {
	onPublish: () => void;
	isLoading: boolean;
};

export function CollectNotesEmptyState({
	onPublish,
	isLoading,
}: CollectNotesEmptyStateProps) {
	return (
		<div
			className={clsx(
				"flex flex-col items-center justify-center py-12 px-6",
				"text-center bg-surface-subtle rounded-2xl",
				"border border-dashed border-border-default mt-2",
			)}
		>
			<div
				className={clsx(
					"mb-5 flex h-16 w-16 items-center justify-center rounded-full",
					"bg-brand-primary-soft text-brand-primary shadow-inner",
				)}
			>
				<IconRocket className="w-8 h-8" />
			</div>
			<Title order={4} mb="sm" className="text-text-primary font-bold">
				Collect Notes from Guests
			</Title>
			<Text size="sm" className="text-text-secondary max-w-[320px]" mb="xl">
				Publish your board to start collecting notes and feedback from your
				guests in real-time.
			</Text>
			<Button
				variant="filled"
				color="var(--ui-color-brand-primary)"
				size="sm"
				radius="sm"
				className={clsx(
					"min-w-40 shadow-sm hover:shadow-md",
					"transition-all duration-200 hover:scale-[1.02] active:scale-[0.98]",
				)}
				loading={isLoading}
				onClick={onPublish}
				leftSection={<IconRocket width={18} height={18} />}
			>
				Publish Now
			</Button>
		</div>
	);
}
